import { Relation } from "@nozbe/watermelondb";
import { Associations } from "@nozbe/watermelondb/Model";
import {
  date,
  field,
  immutableRelation,
  text,
} from "@nozbe/watermelondb/decorators";
import { StockCountItemStatus } from "@towersystems/roam-common/lib/generated-types";
import StockCountLine from "./StockCountLine";
import { SyncMeta } from "./SyncMeta";
import { SyncState } from "../constants";

export default class StockCountItem extends SyncMeta {
  static table = "stock_count_items";

  static associations: Associations = {
    stock_count_lines: { type: "belongs_to", key: "stock_count_line_id" },
  };

  @immutableRelation("stock_count_lines", "stock_count_line_id")
  stockCountLine: Relation<StockCountLine>;

  @text("status") status: StockCountItemStatus | null;
  @text("remote_id") remoteId: string | null;
  @field("counted") counted: number | null;
  @date("counted_at") countedAt: Date | null;
  @date("created_at") createdAt: Date | null;
  @date("updated_at") updatedAt: Date | null;
  @date("deleted_at") deletedAt: Date | null;

  hasSyncFailed() {
    const isUploaded = this.syncState !== SyncState.UPLOADED;
    const hasAttemptedSync = !!this.numSyncAttempts;

    const isFailed = isUploaded && hasAttemptedSync;

    return isFailed;
  }

  async hasExportFailed() {
    const isUploaded = this.syncState === SyncState.UPLOADED;
    const isPending = this.status === StockCountItemStatus.PENDING;

    const potentiallyFailed = isUploaded && isPending;

    if (potentiallyFailed) {
      const stockCountLine = await this.stockCountLine.fetch();
      const stockCount = await stockCountLine.stockCount.fetch();

      // if we have fetched since the last upload, then we can check if it has errored
      if (stockCount.itemsLastFetchMillis) {
        const exportFailed =
          this.updatedAt &&
          this.updatedAt.getTime() < stockCount.itemsLastFetchMillis;

        return exportFailed;
      }
    }
    // if we haven't fetched since the last upload, then we can't check if it has errored
    return false;
  }
}
